import { autorun } from "mobx";

export const settingsStyles = theme => ({
    outerContainer: {
        paddingTop: '4vh',
        display: 'flex',
        justifyContent: 'space-between',
        paddingRight: '2vw',
    },
    editSvg:{
        position: 'absolute',
        top: '47%',
        left: '39%',
        display: 'none'
        
    },
    tooltip:{
    
    },

    profilePic:{
        width: '100%',
        height: '100%'
    },

    profile:{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden',
        '&:hover': {
                '& $editSvg': {
                    display: 'initial'
                }
          
            
          }
    },
    heading: {
        fontSize: '28px',
        fontWeight: 300,
        color: theme.palette.coolGray,
        paddingLeft: '3vw',
    },
    showPassword:{
        cursor:  'pointer'
    },
    svg:{
        marginRight: '1vw'
    },
    loading: {
        top: '40%',
        right: '45%',
        position: 'fixed'
    },
    innerContainer: {
        marginTop: '6vh',
        paddingLeft: '3vw',
        width: '580px',
        backgroundColor: theme.palette.dark,
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
        margin: '1vh 0vw',
        color: 'white',
        fontSize: '15px'
    },
    formStyle: {
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '5vh',
    },
    passwordContainer: {
        height: '11vh',
        borderTop: `1px solid ${theme.palette.steelGray2}`,
        borderBottom: `1px solid  ${theme.palette.steelGray2}`,
        padding: '1vh 0vw',
        display: 'flex',
        justifyContent: 'space-between'
    },
    button: {
        color: theme.palette.white,
        fontSize: '16px',
        backgroundColor: theme.palette.dullGray,
        marginRight: '1vw'
    },
    saveContainer: {
        paddingTop: '7vh',
        display: 'flex'
    },
    backdrop: {
        backdropFilter: 'blur(10px)'
    },
    dialog: {
        minWidth: '27vw',
        minHeight: '20vh',
        backgroundColor: 'transparent',
        boxShadow: 'none'
    },
    passwordButtons:{
        width: '49%',
        color: theme.palette.white,
        fontSize: '16px',
        backgroundColor: theme.palette.dullGray,

    },
    resendMail: {
        textDecoration: 'underline',
        cursor: 'pointer'
    }


})
